// ----------------------------------------------------------------------- imports externos
import { useState } from "react";

// ----------------------------------------------------------------------- imports internos
import { importarPins, sincronizarPlanilla } from "../../services/sincronizarDocs";

/* Los dos botones que traen la planilla del Drive.
 *
 * SON DOS Y NO UNO, y no es que quedó a medio hacer: el segundo mueve el PIN de
 * la tarjeta YPF, que es una credencial de pago. Meterlo adentro de
 * «Sincronizar» lo convertiría en un efecto de apretar otra cosa, cuando tiene
 * que ser una decisión. Por eso también piden permisos distintos —
 * `cargar.documentos` y `ver.pin_ypf`— y los verifica el servidor.
 *
 * ── TRES COSAS QUE LA PANTALLA TIENE QUE DECIR ────────────────────────────
 *
 *   · QUE ESTÁ TRABAJANDO. Bajar la planilla y volcarla tarda unos segundos.
 *     Un botón que no cambia invita a apretarlo de nuevo, y quedan dos
 *     sincronizaciones pisándose.
 *   · QUÉ PASÓ, con el número. «Listo» a secas no distingue traer 219 choferes
 *     de traer cero.
 *   · Y SI FALLÓ, POR QUÉ. Un botón que no hace nada sin decir por qué es lo
 *     que hace que se deje de apretar — y después que se deje de creer que la
 *     pantalla está actualizada.
 *
 * El botón NO se esconde cuando falta el permiso: se muestra el resultado del
 * servidor, que es el que decide. Esconderlo haría que «no tengo el permiso» y
 * «el botón no está» se vean igual — le pasó al dueño del sistema con la
 * ticketera.
 */
const TraerPlanilla = ({ alTerminar = null }) => {
  const [haciendo, setHaciendo] = useState("");
  const [resultado, setResultado] = useState(null);

  const correr = async (cual, fn) => {
    setHaciendo(cual);
    setResultado(null);
    try {
      const r = await fn();
      setResultado(r);
      /* Sólo se recarga la tabla si algo cambió. Recargar tras un fallo
       * mostraría los mismos datos de antes justo debajo de un cartel de
       * error, que se lee como que sí se actualizó. */
      if (r.ok && alTerminar) alTerminar();
    } catch (e) {
      setResultado({ ok: false, mensaje: e.message || "No se pudo." });
    } finally {
      setHaciendo("");
    }
  };

  return (
    <div className="traer">
      <button
        className="tk-chip"
        disabled={Boolean(haciendo)}
        onClick={() => correr("docs", sincronizarPlanilla)}
        title="Baja la planilla del Drive y completa lo que falte. No pisa lo que se corrigió acá."
      >
        {haciendo === "docs" ? "Sincronizando…" : "Sincronizar planilla"}
      </button>
      <button
        className="tk-chip"
        disabled={Boolean(haciendo)}
        onClick={() => correr("pins", importarPins)}
        title="Sube los PIN de la tarjeta YPF. Va aparte porque es una credencial de pago."
      >
        {haciendo === "pins" ? "Importando…" : "Importar PIN"}
      </button>

      {resultado && (
        <span className={"traer-msg" + (resultado.ok ? "" : " traer-msg--mal")}>
          {resultado.mensaje}
        </span>
      )}
    </div>
  );
};

export default TraerPlanilla;
